import { ROUTES } from "@Src/constants/Routes";

const handleExternalRedirect = (targetUrl) => {
  const url = ROUTES.REDIRECT_ROUTE;
  window.localStorage.setItem("ruri", encodeURIComponent(targetUrl));
  window.open(url, "external_url");
};

export { handleExternalRedirect };
